import {
  defaultUrlTransform
} from "../../../chunk-O3JOE2NW.mjs";
import "../../../chunk-XNL3XVS2.mjs";
import "../../../chunk-NEG2FAMT.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMarkdown/urlTransform.ts
function chatUrlTransform(url, key) {
  return key === "href" && url.startsWith("mention:") ? url : defaultUrlTransform(url);
}
function resolvedLinksUrlTransform(url, key) {
  return key === "href" ? url : "";
}
export {
  chatUrlTransform,
  resolvedLinksUrlTransform
};
//# sourceMappingURL=urlTransform.mjs.map